import type { PermissionId } from "@/constants/permissions.constants";
import type { Role } from "@/routerConfig";
import type {
  TBUserType,
  UserAppPermissions,
  UserPermissions,
} from "@/types/data";
import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";

export type UserSlice = {
  roles: Role[];
  firstName: string;
  lastName: string;
  email: string;
  customerName: string;
  userAppPermissions: UserAppPermissions;
};

const initialState: UserSlice = {
  roles: [],
  firstName: "",
  lastName: "",
  email: "",
  customerName: "",
  userAppPermissions: {},
};

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUserInfo: (state, action: PayloadAction<TBUserType>) => {
      const { firstName, lastName, email, additionalInfo } = action.payload;
      state.email = email;
      state.firstName = firstName;
      state.lastName = lastName;
      state.roles = additionalInfo.description
        .split(",")
        .map((role) => role.trim()) as Role[];
    },
    setCustomerName: (state, action: PayloadAction<string>) => {
      state.customerName = action.payload;
    },
    setPermission: (
      state,
      action: PayloadAction<{
        page: PermissionId;
        userPermissions: UserPermissions;
      }>
    ) => {
      const { page, userPermissions } = action.payload;
      state.userAppPermissions[page] = userPermissions;
    },
    resetAllPermissions: (state) => {
      state.userAppPermissions = initialState.userAppPermissions;
    },
  },
});

export const {
  setUserInfo,
  setCustomerName,
  setPermission,
  resetAllPermissions,
} = userSlice.actions;

export default userSlice.reducer;
